module.exports = __webpack_public_path__ + "static/media/swords-power-pink.dfb59608.svg";